function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M17.75 7.05C17.51 7.01 17.26 7 17 7H7c-.28 0-.55.02-.81.06.14-.28.34-.54.58-.78l3.25-3.26a3.525 3.525 0 014.96 0l1.75 1.77c.64.63.98 1.43 1.02 2.26z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M2 16.36V12c0-2.72 1.64-4.62 4.19-4.94.26-.04.53-.06.81-.06h10c.26 0 .51.01.75.05C20.33 7.35 22 9.26 22 12v5c0 2.76-2.24 5-5 5H7c-2.76 0-5-2.24-5-5v-.64z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 12.5h-3c-1.1 0-2 .9-2 2s.9 2 2 2h3M1.23 21.68l.76-.76c-.4-.6-.63-1.32-.63-2.09a3.82 3.82 0 113.82 3.82c-.77 0-1.49-.23-2.09-.63l-.76.76a.78.78 0 01-.55.23c-.2 0-.4-.08-.55-.23a.767.767 0 010-1.1z"
})));